import { Divider, Tag } from "antd";

import { getToken, getUser, getRole } from "../helpers/auth";

const SwitchApp = (props) => {
  const getUserSessionData = () => {
    const token = getToken();
    const role = getRole();
    const user = getUser();
    return { token, role, user };
  };

  const handleAppClick = (app) => {
    const { token, role, user } = getUserSessionData();

    const url = new URL(app.link);

    if (token) url.searchParams.append("token", token);
    if (role) url.searchParams.append("role", role);
    if (user) url.searchParams.append("user", JSON.stringify(user));

    window.open(url.toString(), "_blank", "noopener,noreferrer");
  };

  const apps = [
    {
      name: "CareOS",
      logo: "PROVIDER",
      subtext: "OS",
      description: "Healthcare Provider Management",
      isActive: true,
      link: "#",
      color: "#0991cc",
      icon: "🏥",
    },
    {
      name: "BenefitsOS",
      logo: "BENEFITS",
      subtext: "OS",
      description: "Benefits & Claims Management",
      isActive: false,
      link: process.env.REACT_APP_BOS_URL || "https://bos.rivia.care",
      color: "#059669",
      icon: "💊",
    },
  ];

  return (
    <div className="container-fluid">
      <div className="row justify-content-center">
        <div className="col-12">
          <div className="card shadow-sm border-0 rounded-3">
            <div className="card-body p-4">
              <div className="text-center mb-4">
                <h4 className="fw-bold text-dark mb-2">Switch Application</h4>
                <p className="text-muted mb-0">
                  Select the application you want to switch to
                </p>
              </div>

              <Divider className="my-4" />

              {/* Apps Grid */}
              <div className="row g-4">
                {apps.map((app, index) => (
                  <div key={index} className="col-md-6">
                    <div
                      className="app-card h-100 border-0 rounded-3 position-relative overflow-hidden"
                      style={{
                        backgroundColor: app.color,
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                        minHeight: "200px",
                        opacity: 1,
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-8px)";
                        e.currentTarget.style.boxShadow =
                          "0 12px 24px rgba(0,0,0,0.15)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow =
                          "0 4px 12px rgba(0,0,0,0.1)";
                      }}
                      onClick={() => handleAppClick(app)}>
                      <div
                        className="position-absolute top-0 end-0"
                        style={{
                          width: "80px",
                          height: "80px",
                          background: "rgba(255,255,255,0.1)",
                          borderRadius: "0 12px 0 80px",
                        }}
                      />

                      <div className="d-flex flex-column h-100 p-4 text-white">
                        <div className="text-center mb-3">
                          <div className="display-4 mb-2">{app.icon}</div>
                        </div>

                        <div className="text-center mb-3">
                          <div
                            className="fw-bold mb-1"
                            style={{ fontSize: "16px", letterSpacing: "1px" }}>
                            {app.logo}
                          </div>
                          <div
                            className="fw-bold"
                            style={{ fontSize: "48px", lineHeight: "1" }}>
                            {app.subtext}
                          </div>
                        </div>

                        <div className="text-center mb-3">
                          <p
                            className="mb-0 opacity-75"
                            style={{ fontSize: "14px" }}>
                            {app.description}
                          </p>
                        </div>

                        <div className="mt-auto text-center">
                          {app.isActive && (
                            <Tag
                              color="success"
                              className="px-3 py-1 rounded-pill"
                              style={{
                                backgroundColor: "rgba(255,255,255,0.2)",
                                border: "1px solid rgba(255,255,255,0.3)",
                                color: "white",
                              }}>
                              Active
                            </Tag>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="text-center mt-5">
                <p className="text-muted small mb-0">
                  Secure authentication will be maintained across applications
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { SwitchApp };
